import React from 'react';
import './QuizRecommendationCard.css';

interface QuizRecommendationCardProps {
  recommendationIndex: number;
  title: string;
  description: string;
  ctaLabel: string;
  onSelect: () => void;
}

const QuizRecommendationCardComponent: React.FC<QuizRecommendationCardProps> = ({
  recommendationIndex,
  title,
  description,
  ctaLabel,
  onSelect,
}) => (
  <article className="quiz-recommendation-card">
    <div className="quiz-recommendation-card__index" aria-hidden="true">
      {String(recommendationIndex).padStart(2, '0')}
    </div>
    <h3 className="quiz-recommendation-card__title">
      {title}
    </h3>
    <p className="quiz-recommendation-card__description">
      {description}
    </p>
    <button type="button" className="quiz-recommendation-card__cta" onClick={onSelect}>
      {ctaLabel}
    </button>
  </article>
);

export const QuizRecommendationCard = React.memo(QuizRecommendationCardComponent);
